module.exports = __webpack_public_path__ + "static/media/zero-knowledge-proofs-theory.36357aeb.jpg";